import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const TrainIcon = ({ title = 'Train', ...props }: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 64 64" {...props}>
    <g transform="translate(16 6)" stroke="currentColor" fill="none" fillRule="evenodd">
      <rect y="3.855" width="32.764" height="38.545" rx="2" />
      <path d="M13.49 3.855H9.637V.993c0-.549.443-.993.993-.993h1.87c.547 0 .992.442.992.993v2.862ZM23.127 3.855h-3.854V.993c0-.549.442-.993.992-.993h1.87c.548 0 .992.442.992.993v2.862Z" />
      <path d="M11.082 7.227h10.6" strokeLinecap="round" />
      <rect strokeLinejoin="round" x="3.855" y="10.6" width="25.055" height="12.527" rx="1" />
      <circle cx="8.673" cy="33.727" r="2.891" />
      <circle cx="24.091" cy="33.727" r="2.891" />
      <path
        d="M8.19 45.773 1.91 52.055M24.573 45.773l6.282 6.282M4.336 49.627h24.091"
        strokeLinecap="round"
      />
    </g>
  </CreateIconComponent>
);

export default TrainIcon;
